import { render } from "./radio-button-group.component.vue?vue&type=template&id=c5dc2466&ts=true"
import script from "./radio-button-group.component.vue?vue&type=script&lang=ts"
export * from "./radio-button-group.component.vue?vue&type=script&lang=ts"

import "./radio-button-group.component.vue?vue&type=style&index=0&id=c5dc2466&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__